import { apiCall } from '../../utils/restclient'
import {
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_ERROR,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_ERROR,
} from './ResetPasswordConstants'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const updatePassword = (body) => {
  const endpoint = 'api/v1/auth/resetpassword'
  const action = {
    type: UPDATE_PASSWORD,
    payload: { endpoint, body: { ...body } },
  }
  // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
  apiCall(endpoint, 'PUT', null, JSON.stringify(action.payload.body), {
    success: UPDATE_PASSWORD_SUCCESS,
    error: UPDATE_PASSWORD_ERROR,
  })
  return action
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const createPasswordForNewMember = (body) => {
  const endpoint = 'api/v1/auth/verifyemail'
  const action = {
    type: UPDATE_PASSWORD,
    payload: { endpoint, body: { ...body } },
  }
  // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
  apiCall(endpoint, 'PUT', null, JSON.stringify(action.payload.body), {
    success: UPDATE_PASSWORD_SUCCESS,
    error: UPDATE_PASSWORD_ERROR,
  })
  return action
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const resendForgotPassword = (body) => {
  const endpoint = 'api/v1/auth/forgotpassword'
  const action = {
    type: FORGOT_PASSWORD,
    payload: { endpoint, body: { ...body } },
  }
  // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
  apiCall(endpoint, 'POST', null, JSON.stringify(action.payload.body), {
    success: FORGOT_PASSWORD_SUCCESS,
    error: FORGOT_PASSWORD_ERROR,
  })
  return action
}
